import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px 16px;
  box-sizing: border-box;
`
export const Preview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const PreviewLabel = styled.label`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const PreviewContainer = styled.div`
  display: flex;
  padding: 32px 62px 0 62px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Comm-Primary-100, #e0e8ff);
  gap: 12px;
`

export const ObjectBanner = styled.div`
  display: flex;
  height: 54px;
  padding: 0px 40px;
  flex: 1;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background: var(--Background-Elevation-base, #fff);
  gap: 6px;

  border-radius: 8px;
`

export const ObjectBannerObjectLabel = styled.h3`
  color: #14171f;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`

export const ObjectBannerLabel = styled.div`
  color: #14171f;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;
  overflow-wrap: break-word;
  flex: 1;
  min-width: 0;

  display: flex;
  align-items: center;
  height: 100%;
`

export const PreviewContent = styled.div`
  display: flex;
  border-radius: 8px;
  width: 100%;
  height: 400px;
  padding: 32px 40px 32px 40px;
  align-items: flex-start;
  flex-direction: column;
  flex-shrink: 0;
  border-radius: 6px 6px 0px 0px;
  background: #fff;
  gap: 20px;
`

export const PreviewContentTitle = styled.h2`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`

export const PreviewContentBody = styled.div`
  color: #14171f;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

export const PreviewContentFooter = styled.div`
  color: #14171f;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`

export const PreviewButtonJoinProject = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    var(--Foreground-Primary, #4d4be7);
  background-blend-mode: soft-light, normal;
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: var(--On-background-Primary, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

export const ImgLogo = styled.img`
  max-height: 60px;
`

export const EmailSpan = styled.span`
  color: #4d4be7;
  font-weight: 400;
  text-decoration: none;
  text-decoration-line: underline;
`

export const PersonNameSpan = styled.span`
  font-weight: 400;
  color: #14171f;
`

export const ProjectNameSpan = styled.span`
  font-weight: 400;
  color: #14171f;
`

export const GreetingsSpan = styled.span`
  font-weight: 400;
  color: #14171f;
`

export const GreetingsParagraph = styled.div`
  margin-bottom: 16px;
`

export const BodyParagraph = styled.div`
  margin: 0;
`
